import React, { useRef, useEffect, useState } from 'react';
import { GetEchartsOption } from '../assets';
import style from './index.module.less';
import useScreenSize from '@/lib/hooks/utils/useScreenSize';
import { useTranslation } from 'next-i18next';
import { loadECharts } from '@/lib/utils/echarts';

const DailyNewFollower: React.FC<any> = ({ mediaName, dataInfo }) => {
  const { width } = useScreenSize();
  const { t } = useTranslation();
  const divRef = useRef();
  const [echartsLoaded, setEchartsLoaded] = useState(false);
  const [instance, setInstance] = useState(null);

  // 整理数据
  const dataArrTemp = Array.from([...(dataInfo ?? [])])
    .reverse()
    .map((item: any) => ({
      data_date: item.data_date,
      daily_new_follower_num: item.daily_new_follower_num,
    }));
  const dataArr = dataArrTemp.filter((item: any) => item.daily_new_follower_num);
  const dataTime = dataArr.map((item: any) => item.data_date);
  const daily_new_follower_num = dataArr.map((item: any) => item.daily_new_follower_num);
  let option = GetEchartsOption('second');
  option.xAxis.data = dataTime;
  option.series[0].data = daily_new_follower_num;

  // 加载ECharts
  useEffect(() => {
    let isMounted = true;

    const initEcharts = async () => {
      if (typeof window !== 'undefined' && divRef.current) {
        try {
          const echarts = await loadECharts();
          if (isMounted && divRef.current) {
            const chart = echarts.init(divRef.current);
            chart.setOption(option);
            setInstance(chart);
            setEchartsLoaded(true);
          }
        } catch (error) {
          console.error('Failed to load ECharts:', error);
        }
      }
    };

    initEcharts();

    return () => {
      isMounted = false;
      if (instance) {
        instance.dispose();
      }
    };
  }, []);

  // 更新数据
  useEffect(() => {
    if (instance && echartsLoaded) {
      instance.setOption(option);
    }
  }, [dataInfo, echartsLoaded]);

  // 响应式调整大小
  useEffect(() => {
    if (instance && echartsLoaded) {
      instance.resize();
    }
  }, [width, echartsLoaded]);

  return (
    <div
      className={style.chartCon}
      ref={divRef}
      aria-label={t("Line chart of 1xx1's Instagram daily new followers from 2xx2, to 3xx3.")
        ?.replace('1xx1', mediaName)
        ?.replace('2xx2', dataArrTemp?.at(0)?.data_date)
        ?.replace('3xx3', dataArrTemp?.at(dataArrTemp?.length - 1)?.data_date)}
    />
  );
};

export default DailyNewFollower;
